import React from 'react'

import { Link } from 'react-router-dom'

import style from './ReviewDisplay.module.css'

import { Chart } from 'common/components'
import { useAppSelector } from 'common/hooks'
import { Paths } from 'common/routes'
import { getCardImage } from 'common/utils'
import { selectCategory } from 'features/dashboard'
import { selectCurrentTask } from 'features/simulator'

type PropsType = {
  nextTaskId: string
}

const getReviewMessage = (result: number) => {
  let message = ''

  if (result >= 600) {
    message = 'Кажется, ты отлично умеешь пользоваться инструментами разработчика :)'
  } else if (result > 190 && result < 600) {
    message = 'Отличный результат! Переходи к следующей категории или продолжай совершенствоваться.'
  } else if (result > 100 && result <= 190) {
    message = 'Неплохо! Продолжай тренировки и следи за своим прогрессом.'
  } else {
    message = `Необходимо потренироваться еще, чтобы достичь результата и быть “реактивным” разрабом! :)`
  }

  return message
}

export const ReviewDisplay = ({ nextTaskId }: PropsType) => {
  const task = useAppSelector(selectCurrentTask)!
  const symbolsPerMinute = useAppSelector(state => state.simulator.results.symbolsPerMinute)!
  const category = useAppSelector(state => selectCategory(state, task.categoryId))

  return (
    <div className={`box ${style.box}`}>
      <div className={style['text-column']}>
        <h3 className={style.title}>Задание выполнено!</h3>
        <p>{getReviewMessage(symbolsPerMinute)}</p>
        <div className={style['properties-box']}>
          <p className={style.property}>Символов в минуту: {symbolsPerMinute}</p>
          <p className={style.property}>Всего тренировок: {category?.activities.attempts}</p>
        </div>
      </div>
      <div className={style['chart-column']}>
        <Link
          to={`${Paths.Simulator}${nextTaskId}`}
          className={style['image-link']}
          title="Следующая тренировка"
        >
          <img src={getCardImage(category!.title)} width="40" height="40" alt={category!.title} />
        </Link>
        <Chart
          className={style.chart}
          data={category!.activities.results}
          width={300}
          height={150}
        />
      </div>
    </div>
  )
}
